import { render, staticRenderFns } from "./LineBreakText.vue?vue&type=template&id=43dc4dcd&scoped=true&"
import script from "./LineBreakText.vue?vue&type=script&lang=js&"
export * from "./LineBreakText.vue?vue&type=script&lang=js&"
import style0 from "./LineBreakText.vue?vue&type=style&index=0&id=43dc4dcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dc4dcd",
  null
  
)

export default component.exports